import type { TFunction } from 'i18next';
import { isKnownStatus, type StatusDomain } from '@/theme/statusTones';

export type LabelValues = Record<string, string | number>;

/** A status's catalog wording; "Unknown status" for one the registry does not know. */
export function statusLabel(
  t: TFunction,
  domain: StatusDomain,
  status: string | null | undefined,
  values?: LabelValues,
): string {
  return isKnownStatus(domain, status)
    ? t(`status.${domain}.${status}`, { ...values })
    : t('status.unknown');
}
